import React, { useRef, useState, useEffect } from 'react';

import {
  Box,
  Button,
  IconButton,
  Typography,
  FormControl,
} from '@mui/material';
import PropTypes from 'prop-types';
import { FastField } from 'formik';
import { get, set, isEmpty } from 'lodash';
import DeleteForever from '@mui/icons-material/DeleteForever';

const FileInput = ({
  name,
  fileInfo,
  placeholder,
  setFieldValue,
  buttonPlaceholder,
  ...rest
}) => {
  const fileChooser = useRef(null);
  const [hasFile, setHasFile] = useState(false);
  const [attachment, setAttachment] = useState(null);

  const handleSelectedFile = () => attachment !== null;
  const handleResetSelection = (setFieldValue) => {
    set(fileChooser, 'current.value', '');
    setFieldValue(name, null);
    setAttachment(null);
  };

  const handleFileSelection = (e, setFieldValue) => {
    const attachmentFile = e.target.files[0];
    setFieldValue(name, attachmentFile);
    setAttachment(attachmentFile);
  };

  useEffect(() => {
    if (!isEmpty(fileInfo)) {
      setHasFile(true);
    }
  }, [fileInfo]);

  return (
    <>
      <Typography style={{ marginLeft: 5 }}>{placeholder}</Typography>
      {hasFile ? (
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography style={{ marginLeft: 5, marginRight: 5 }}>
            {fileInfo}
          </Typography>
          <IconButton
            aria-label="close"
            onClick={() => {
              setFieldValue(name, null);
              setHasFile(false);
            }}>
            <DeleteForever color="error" />
          </IconButton>
        </Box>
      ) : (
        <FastField name={name}>
          {() => (
            <FormControl style={{ width: '100%' }}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between">
                <Button
                  color="secondary"
                  onClick={() => fileChooser.current.click()}>
                  {get(attachment, 'name', buttonPlaceholder)}
                </Button>
                {handleSelectedFile() && (
                  <IconButton
                    aria-label="close"
                    onClick={() => handleResetSelection(setFieldValue)}>
                    <DeleteForever color="error" />
                  </IconButton>
                )}
                <input
                  {...rest}
                  type="file"
                  ref={fileChooser}
                  style={{ display: 'none' }}
                  onChange={(event) =>
                    handleFileSelection(event, setFieldValue)
                  }
                />
              </Box>
            </FormControl>
          )}
        </FastField>
      )}
    </>
  );
};

FileInput.propTypes = {
  fileInfo: PropTypes.string,
  setFieldValue: PropTypes.func,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  buttonPlaceholder: PropTypes.string.isRequired,
};

export default FileInput;
